const layout = () => import("../../internal/layout.vue");
const documentacao = () => import("./documentacao.vue");

const DocumentacaoRoutes = {
  component: layout,
  children: [
    {
      path: "",
      name: "documentacao",
      meta: {
        title: "Documentação",
        requiresAuth: true,
      },
      component: documentacao,
    },
  ],
};

export default DocumentacaoRoutes;